import {
    Box,
    Button,
    Card,
    CardHeader,
    CircularProgress,
    Divider,
    FormControlLabel,
    Grid,
    IconButton,
    Switch
} from "@mui/material";
import React, { useState } from "react";
import { useLoaderData, useNavigate } from "react-router-dom";
  
  
  import Refresh from "@mui/icons-material/Refresh";
import SyncIcon from "@mui/icons-material/Sync";
import DefaultApiService from "../../../../infrastructure/api/default";
  
  import { toast } from "react-toastify";
import useGetPageInfo from "../../../common/hooks/useGetPageInfo";
import DeleteConfirm from "../../../components/shared/Dialog/DeleteConfirm";
import BreadcrumbsComponent from "../../../components/shared/breadcrumbs";
  
  const LicensePage = () => {
    const roleInfoList = useLoaderData("root");
    let navigate = useNavigate();
    const pageInfo = useGetPageInfo();
    const [loading, setLoading] = useState(false);
    const [deleteConfirm, setDeleteConfirm] = useState({
      open: false,
      data: {},
    });
    const [cascadeDelete, setCascadeDelete] = useState(false);
    const headCells = [
      {
        id: "roleId",
        disablePadding: false,
        label: "ایدی",
      },
      {
        id: "roleName",
        disablePadding: false,
        label: "عنوان",
      },
      {
        id: "updateOn",
        type: "date",
        disablePadding: true,
        label: "تاریخ بروزرسانی",
      },
      {
        id: "defaultUrl",
        disablePadding: false,
        label: "مسیر پیش فرض",
      },
      {
        id: "isActive",
        type: "boolean",
        disablePadding: false,
        label: "وضعیت",
      },
      {
        id: "roleDescription",
        numeric: false,
        disablePadding: false,
        label: "شرح",
      },
    ];
  
  
    
    const onUpdateData = async () => {
      setLoading(true);
      try {
        const res = await DefaultApiService.getCustomeApi(
          "UM/License/UpdateLicense"
        );
  
        if (res.isSuccess) {
          toast.success(res.message);
          onFetchData();
        } else {
          toast.error(res.message);
        }
  
        setLoading(false);
      } catch (error) {
        toast.error(error?.response?.data?.message || "خطایی رخ داده است.");
  
        setLoading(false);
      }
    };
  
    
  
    
     
  
    const onFetchData = () => {
      navigate();
    };
  
    return (
      <Grid container spacing={3}>
        <Grid item xs={12} md={12}>
          <BreadcrumbsComponent />
  
          <DeleteConfirm
            message={`برای حذف دیتای "${deleteConfirm.data.roleName}" اطمینان دارید؟`}
            open={deleteConfirm.open}
            onClose={(loadAgain) => {
              setDeleteConfirm({
                open: false,
                data: {},
              });
              setCascadeDelete(false);
              if (loadAgain) {
                navigate();
              }
            }}
            
          >
            <Grid
              item
              xs={12}
              md={12}
              container
              justifyContent={"center"}
              sx={{ my: 1 }}
            >
              <FormControlLabel
                name="cascadeDelete"
                checked={cascadeDelete}
                onChange={(event) => {
                  setCascadeDelete(event.target.checked);
                }}
                control={<Switch color="info" />}
                label="حذف کاربران زیرمجموعه این گروه"
              />
            </Grid>
          </DeleteConfirm>
        </Grid>
  
        <Grid item xs={12} md={12}>
          <Card>
            <CardHeader
              title={pageInfo.title}
              action={
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    width: "fit-content",
                  }}
                >
  
  <Button
                    variant="contained"
                    color="info"
                    onClick={onUpdateData}
                    startIcon={<Refresh />}
                    disabled={loading}
                  >
                    بروزرسانی
                    {loading && <CircularProgress size={16} color="inherit" />}
                  </Button>
  
                  <Divider
                    orientation="vertical"
                    variant="middle"
                    flexItem
                    sx={{ mx: 1 }}
                  />
  
                 
  
                  <Divider
                    orientation="vertical"
                    variant="middle"
                    flexItem
                    sx={{ mx: 1 }}
                  />
  
                  <IconButton
                    variant="text"
                    color="primary"
                    onClick={onFetchData}
                  >
                    <SyncIcon />
                  </IconButton>
                </Box>
              }
            />
  
             
          </Card>
        </Grid>
      </Grid>
    );
  };
  
  export default LicensePage;
  